<template>
  <q-card-section class="funButton font-size-14 no-padding q-mx-lg">
    <div v-if="status && status.statusCode === 200" class="btnList">
      <q-btn
        v-if="storeInfo.dineIn"
        no-caps
        unelevated
        @click="goList('DINE_IN')"
      >
        <img :src="icons.dineIn" alt srcset />
      </q-btn>
      <q-btn
        v-if="storeInfo.pickUp"
        no-caps
        unelevated
        @click="goList('PICK_UP')"
      >
        <img :src="icons.pickUp" alt srcset />
      </q-btn>
      <q-btn
        v-if="storeInfo.fullDineIn && table"
        no-caps
        unelevated
        @click="goList('FULL_DINE_IN')"
      >
        <img :src="icons.dineIn" alt srcset />
      </q-btn>
      <q-btn
        v-if="storeInfo.delivery"
        no-caps
        unelevated
        @click="goList('DELIVERY')"
      >
        <img :src="icons.delivery" alt srcset />
      </q-btn>
    </div>
    <div v-else>
      <q-btn no-caps unelevated style="width: 100%" @click="goList('PICK_UP')">
        {{ $t('home.menu') }}
        <span class="iconfont right-icon">&#xe744;</span>
      </q-btn>
      <!--关店时的full dine按钮-->
      <q-btn
        v-if="storeInfo.fullDineIn && table"
        no-caps
        unelevated
        style="width: 100%"
        @click="goList('FULL_DINE_IN')"
      >
        <img :src="icons.dineIn" alt srcset />
      </q-btn>
    </div>
  </q-card-section>
</template>

<script>
import { mapState } from 'vuex';
import { setTable, getTable, clearTable } from 'src/utils/common';

export default {
  props: {
    status: {
      type: Object,
      default: () => {},
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      table: getTable(),
      icons: {
        schedule:
          'https://static.bakmigm.co.id/menu/ykitchen-6329a03b14327c63d9d5ee372b54ef661.png',
        pickUp:
          'https://static.bakmigm.co.id/menu/Pickup.png',
        dineIn:
          'https://static.bakmigm.co.id/menu/ykitchen-7c15783ace60c63d5aefee0fa5b2cb0e3.png',
        delivery:
          'https://static.bakmigm.co.id/menu/ykitchen-9d361a344a8bc5437c2d3ccc919912274.png',
      },
    };
  },
  computed: {
    ...mapState({
      nearestStatus: (state) => state.Menu.nearestStatus,
    }),
  },
  mounted() {
    this.table = this.$route.query.table || getTable();
    if (this.table) {
      setTable(this.table, 1000 * 60 * 60 * 12);
    } else {
      clearTable();
    }
  },
  methods: {
    goList(type) {
      if (type === 'DELIVERY') {
        if (this.info && this.info.chainStore && !this.nearestStatus) {
          this.$store.commit('Menu/updateAccessStatus', type);
          this.$store.commit('Menu/updateScheduled', false);
          this.$emit('showNearest');
        } else {
          this.handleGoList(type);
        }
      } else {
        this.handleGoList(type);
      }
      // this.handleGoList(type);
    },
    handleGoList(type) {
      const url = this.$route.params.store;
      this.$store.commit('Menu/updateAccessStatus', type);
      this.$store.commit('Menu/updateScheduled', false);
      this.$router.push({
        path: `/${url}/products-list`,
        query: { table: this.table },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.funButton {
  margin-top: 16px;
  .btnList {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .q-btn {
    background: #fff;
    display: block;
    height: 94px;
    margin: 4px;
    border-radius: 10px;
    color: $black;
    font-weight: 800;
    word-break: keep-all;
    flex: 1;
    ::v-deep .q-btn__content {
      flex-direction: column;
      line-height: 1.2;
    }
    ::v-deep .q-btn__wrapper {
      padding: 0;
    }
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    img {
      height: 88px;
    }
    .right-icon {
      display: none;
      background: transparent;
      color: $primary;
      font-size: 20px;
      position: absolute;
      right: 8px;
    }
  }
}
</style>
